import { useEffect, useRef, useState } from "react";
import { useLocation } from "@tanstack/react-router";

export function NavProgress() {
  const pathname = useLocation({ select: (s) => s.pathname });
  const [loading, setLoading] = useState(false);
  const prevPathname = useRef(pathname);

  useEffect(() => {
    if (pathname !== prevPathname.current) {
      prevPathname.current = pathname;
      setLoading(false);
    }
  }, [pathname]);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const anchor = (e.target as HTMLElement).closest("a");
      if (!anchor) return;
      const href = anchor.getAttribute("href");
      if (!href || href.startsWith("http") || href.startsWith("#")) return;
      if (href !== pathname) {
        setLoading(true);
      }
    };
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, [pathname]);

  if (!loading) return null;

  return (
    <div className="fixed top-0 left-0 z-100 h-0.5 w-full animate-[progress-fade_0s_100ms_forwards]">
      <div className="h-full w-1/3 animate-[progress_1s_100ms_ease-in-out_infinite] bg-primary" />
    </div>
  );
}
